export default __webpack_public_path__ + "static/media/smartpoint-calculator.f6761ea3.png";